export default __webpack_public_path__ + "static/media/recetas.4e096a25.svg";